import { render, staticRenderFns } from "./TaskDrawer.vue?vue&type=template&id=1b8c11a4&scoped=true&"
import script from "./TaskDrawer.vue?vue&type=script&lang=js&"
export * from "./TaskDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TaskDrawer.vue?vue&type=style&index=0&id=1b8c11a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c11a4",
  null
  
)

export default component.exports